import "./polyfills.js";
import "./robots.txt";

import "normalize.css";
import "styles/main.scss";

import React from "react";
import ReactDom from "react-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink } from "apollo-link";

import configureStore from "./store/configureStore";
import App from "./components/App";
import { apiLink, errorLink, stateLink } from "utils/apollo/links";
import fragmentMatcher from "utils/apollo/fragmentMatcher";
import { ENABLE_APOLLO_DEVTOOLS } from "config/constants";

if (typeof window !== "undefined") {
  const preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;

  const store = configureStore(preloadedState);

  const cache = new InMemoryCache({ fragmentMatcher }).restore(
    window.__APOLLO_STATE__
  );
  const charonClient = new ApolloClient({
    cache,
    link: ApolloLink.from([errorLink, stateLink({ cache }), apiLink()]),
    connectToDevTools: ENABLE_APOLLO_DEVTOOLS,
  });

  const render = () => {
    (preloadedState ? ReactDom.hydrate : ReactDom.render)(
      <ApolloProvider client={charonClient}>
        <HelmetProvider>
          <Provider store={store}>
            <App />
          </Provider>
        </HelmetProvider>
      </ApolloProvider>,
      document.getElementById("app")
    );
  };

  if (module.hot) {
    module.hot.accept("./components/App", () => {
      render();
    });
  }

  render();
}
